import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { adminApi, apiError } from "../api";
import ImagePicker from "../components/ImagePicker";

const FIELDS = [
  ["name", "Company name"],
  ["short", "Short name"],
  ["tagline", "Tagline"],
  ["phone", "Phone number (10 digits)"],
  ["whatsapp", "WhatsApp number (10 digits)"],
  ["email", "Email"],
  ["location", "Location"],
  ["address", "Office address"],
  ["mapsLink", "Google Maps link"],
  ["instagramHandle", "Instagram handle (without @)"],
  ["instagramUrl", "Instagram URL"],
  ["facebookUrl", "Facebook URL"],
  ["youtubeUrl", "YouTube URL"],
  ["googleReviewsUrl", "Google Reviews URL"],
];

export default function Settings() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.get("/admin/settings").then(({ data }) => setForm(data)).catch((e) => toast.error(apiError(e)));
  }, []);

  const set = (k) => (v) => setForm((s) => ({ ...s, [k]: v?.target ? v.target.value : v }));

  const save = async () => {
    setSaving(true);
    try {
      await adminApi.put("/admin/settings", form);
      toast.success("Settings saved — live on the website now");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };

  if (!form) return <div className="py-16 text-center text-muted-foreground">Loading…</div>;

  return (
    <div data-testid="admin-settings-page" className="max-w-3xl">
      <h1 className="text-2xl font-bold mb-1">Settings</h1>
      <p className="text-sm text-muted-foreground mb-6">Company info shown across the website (navbar, footer, contact page, WhatsApp buttons).</p>

      <div className="rounded-2xl border bg-white dark:bg-slate-900 p-6 grid gap-5">
        <div className="grid sm:grid-cols-2 gap-4">
          {FIELDS.map(([key, label]) => (
            <div key={key} className="grid gap-2">
              <Label>{label}</Label>
              <Input value={form[key] || ""} onChange={set(key)} data-testid={`settings-field-${key}`} />
            </div>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 gap-6">
          <ImagePicker label="Logo" value={form.logo || ""} onChange={set("logo")} folder="misc" />
          <ImagePicker label="Home hero image" value={form.heroImage || ""} onChange={set("heroImage")} folder="hero" />
        </div>
        <Button onClick={save} disabled={saving} className="bg-emerald-500 hover:bg-emerald-600 text-white w-fit" data-testid="save-settings-btn">
          {saving ? "Saving…" : "Save settings"}
        </Button>
      </div>
    </div>
  );
}
